import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPaintBucket: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconPaintBucket"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C15.854 2 19.0407 4.79901 19.8174 8.5H21V10H20V22H4V10H3V8.5H4.18262C4.95927 4.79901 8.146 2 12 2ZM12 3.5C9.01009 3.5 6.46522 5.60758 5.7207 8.5H8V14H9.5V8.5H11V12H12.5V8.5H18.2793C17.5348 5.60758 14.9899 3.5 12 3.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPaintBucket;
